import * as React from 'react'

import { Avatar, Box } from '@factorialco/deprecated-design-system'
import { User } from '@sentry/browser'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Props {
  value: number[]
  onChange: (newValue: number) => void
  error?: string
  accesses: User[]
}

const EmployeeSelector = ({ value, onChange, error, accesses }: Props) => {
  return (
    <Box>
      <Selector.Popover
        placeholder={i18n.t(
          'space_control.overview.booking_sidepanel.employee_selector.placeholder'
        )}
        searchPlaceholder={i18n.t('common.search')}
        blankLabel={i18n.t(
          'space_control.overview.booking_sidepanel.employee_selector.blank_label'
        )}
        value={value}
        label={i18n.t('space_control.overview.booking_sidepanel.employee_selector.label')}
        onChange={(value) => onChange(value as number)}
        error={error}
        isDisabled={accesses.length < 2}
      >
        {accesses.map((access) => (
          <Selector.Option
            key={access.fullName()}
            value={access.id}
            label={access.fullName()}
            searchValue={access.fullName()}
          >
            <Avatar size="s24" label={access.fullName()} url={buildUrl(access.avatar)} />
            {access.fullName()}
          </Selector.Option>
        ))}
      </Selector.Popover>
    </Box>
  )
}

export default observer(EmployeeSelector)
